<nb-layout>
  <nb-layout-header fixed>
    <h1  nbButton="true">
      <a href="https://dasec.ma">
        <img src="../../assets/logoo.svg" width="150rem">
      </a>
    </h1>
  </nb-layout-header>

  <nb-layout-column>


    <div class="row">

      <div class="col-lg-4 col-md-6 col-sm-12">

        <nb-card size="small">
          <nb-card-header>Analysis for Hotels</nb-card-header>
          <nb-card-body>
            <p class="text-justify">A case study for a hotel. Analyzing detailed information collected about a hotel's clients and
              showcasing findings leading to assist decision making in the travel industry. </p>
          </nb-card-body>
          <nb-card-footer class="text-right">
            <a target="_blank" href="https://drive.google.com/file/d/1wZbt74hpMEZyuhKBUaSmeC5Y4pGh15KM/view?usp=sharing">
              <button nbButton status="success">
                See Demo
              </button>
           </a>

          </nb-card-footer>
        </nb-card>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">

        <nb-card size="small">
          <nb-card-header>Real Estate in Casablanca</nb-card-header>
          <nb-card-body>
            <p class="text-justify">A dashboard for analyzing real estate data for Casablanca.
              Granular data is being collected from trusted sources and processed automatically to serve insights via readabe visualizations.
              We can scale a similar approach to multiple cities.</p>
          </nb-card-body>
          <nb-card-footer class="text-right">
            <a target="_blank" href="https://public.tableau.com/app/profile/dasec/viz/PrixdesbureauxCasablanca/Dashboard2">
              <button nbButton status="success">
                See Demo
              </button>
           </a>

          </nb-card-footer>
        </nb-card>
      </div>


      <!--div class="col-lg-4 col-md-6 col-sm-12">

        <nb-card size="small">
          <nb-card-header>Analysis of youtube data: Analysis of gender-based violence stories</nb-card-header>
          <nb-card-body>
            <p class="text-justify">
              Analysis of gender-based violence stories reported in Youtube in Morocco. Youtube is the second most popular website in Morocco. A similar approach can be applied to different topics and data sources.
            </p>
          </nb-card-body>
          <nb-card-footer class="text-right">
            <a target="_blank" href="https://drive.google.com/file/d/19A1nLM74va6JBbIiOzquB-_E2xx9jneY/view">
              <button nbButton status="primary">
                See Report
              </button>
           </a>

          </nb-card-footer>
        </nb-card>
      </div-->




      <div class="col-lg-4 col-md-6 col-sm-12">

        <nb-card size="small">
          <nb-card-header>Competition Analysis: Big Data case study</nb-card-header>
          <nb-card-body>
            <p class="text-justify">Assume an entrepreneur interested in offering big data and artificial intelligence
              (AI) services in Morocco. They are confronted with the task of analyzing the competition, which could be
              a cumbersome task. Here, we collect, process and merge data from various sources including online
              directories, social media, press, companies’ websites and incubators’ websites in order to identify
              companies that provide big data and AI services in Morocco and analyze their characteristics including
              size, sector, capital, creation date, headquarters, description and services. Such work can be replicated
              for other sectors.</p>
          </nb-card-body>
          <nb-card-footer class="text-right">
            <button nbButton routerLink="/companies" status="primary"> See Demo </button>
          </nb-card-footer>
        </nb-card>
      </div>


      <div class="col-lg-4 col-md-6 col-sm-12">

        <nb-card size="small">
          <nb-card-header>Dialisis centers distribution in Morocco</nb-card-header>
          <nb-card-body>
            <p class="text-justify">
              Let's assume a person wants to build a Dialysis Center in Morocco. Let alone the fact that it's an
              expensive project, it's really hard to choose a location where this project is going to be profitable the
              most. To respond to this problem, we collect detailed data from trusted sources about all Dialysis centers
              in Morocco, and provide a dashboard for our users to explore this data and make the best decision.
            </p>
          </nb-card-body>
          <nb-card-footer class="text-right">
            <button nbButton routerLink="/telecontact" status="primary"> See Demo </button>
          </nb-card-footer>
        </nb-card>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">

        <nb-card size="small">
          <nb-card-header>Gallery of Economic Indicators</nb-card-header>
          <nb-card-body>
            <p class="text-justify">International investors continuously monitor countries’ marco-economic indicators in order to assess
              the risk associated with their investments. These indicators are scattered across multiple websites and
              thus monitoring them takes considerable manual effort. Here, we provide a real-time aggregator of
              indicators provided by various international organizations including the WorldBank, IMF, African
              Development Group, Banque Centrale des Etats de l’Afrique de l’Ouest, Food and Agriculture Organization
              of the United Nations, International Labour Organization, China Africa Research Initiative, South African
              Reserve Bank and World trade Organization.</p>
          </nb-card-body>
          <nb-card-footer class="text-right">
            <button nbButton routerLink="/gallery" status="primary"> See Demo </button>
          </nb-card-footer>
        </nb-card>
      </div>



    </div>

  </nb-layout-column>


</nb-layout>
